import React, { useEffect, useState } from "react";
import {
  getDocs,
  getDoc,
  doc,
  collection,
  query,
  orderBy
} from "firebase/firestore";
import { database } from "./firebase";

function Statistics() {
const [users, setUsers] = useState([]);
const [userMnemonics, setUserMnemonics] = useState([]);
const [selectedUser, setSelectedUser] = useState(null);
const [loading, setLoading] = useState(false);
const [userExerciseResults, setUserExerciseResults] = useState([]);
const [userSol, setUserSol] = useState([]);
const [aiUsage, setAiUsage] = useState(null);
const [usageRefresh, setUsageRefresh] = useState(0);
const selectedUserId = selectedUser?.user_id || selectedUser?.id;

useEffect(() => {
  if (!selectedUserId) return;
  let cancelled = false;
  setAiUsage({ userId: selectedUserId, loading: true, data: null, error: '' });
  getDoc(doc(database, "aiUsage", selectedUserId))
    .then(snapshot => {
      if (!cancelled) setAiUsage({
        userId: selectedUserId, loading: false,
        data: snapshot.exists() ? snapshot.data() : null, error: ''
      });
    })
    .catch(error => {
      console.error("Ошибка загрузки aiUsage:", error);
      if (!cancelled) setAiUsage({
        userId: selectedUserId, loading: false, data: null,
        error: 'Не удалось загрузить использование ИИ. Проверьте доступ к aiUsage и повторите загрузку.'
      });
    });
  return () => { cancelled = true; };
}, [selectedUserId, usageRefresh]);

const currentUsage = aiUsage?.userId === selectedUserId ? aiUsage : null;
const formatUsageDate = timestamp => {
  if (!timestamp) return "—";
  const date = typeof timestamp.toDate === 'function'
    ? timestamp.toDate()
    : typeof timestamp.seconds === 'number' ? new Date(timestamp.seconds * 1000) : null;
  return date && !Number.isNaN(date.getTime())
    ? date.toLocaleString('ru-RU', { timeZone: 'America/Argentina/Salta' }) + ' (UTC−3)'
    : "—";
};


const fetchData = async () => {
  setLoading(true);
  setUsageRefresh(value => value + 1);

  try {
    // USERS
    const usersQuery = query(
      collection(database, "users"),
      orderBy("date_created", "desc")
    );

    const usersSnapshot = await getDocs(usersQuery);
    const usersData = usersSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // USER MNEMONICS
    const mnemonicsSnapshot = await getDocs(
      collection(database, "userMnemonics")
    );

    const mnemonicsData = mnemonicsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // USER EXERCISE RESULTS
    const exerciseResultsSnapshot = await getDocs(
      collection(database, "UserExerciseResults")
    );

    const exerciseResultsData = exerciseResultsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // USER SOL
    const userSolSnapshot = await getDocs(
      collection(database, "UserSol")
    );

    const userSolData = userSolSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setUsers(usersData);
    setUserMnemonics(mnemonicsData);
    setUserExerciseResults(exerciseResultsData);
    setUserSol(userSolData);
  } catch (error) {
    console.error("Ошибка загрузки данных:", error);
  } finally {
    setLoading(false);
  }
};

  const formatDate = (timestamp) => {
    if (!timestamp) return "—";
    return new Date(timestamp.seconds * 1000).toLocaleDateString();
  };

  const formatTimestampDate = (timestamp) => {
  if (!timestamp?.seconds) return "—";
  return new Date(timestamp.seconds * 1000).toLocaleDateString();
};

const selectedUserMnemonics = selectedUser
  ? userMnemonics.filter(
      mnemonic => mnemonic.userID === selectedUser.id
    )
  : [];

const selectedUserExerciseResults = selectedUser
  ? userExerciseResults.filter(
      result => result.userID === selectedUser.id
    )
  : [];

const selectedUserSol = selectedUser
  ? userSol.filter(
      item =>
        item.userID === selectedUser.id &&
        item.isBurnt === false
    )
  : [];

const selectedUserSolCount = selectedUserSol.length;

const selectedUserExerciseResultsCount =
  selectedUserExerciseResults.length;

const lastExerciseDate =
  selectedUserExerciseResults.length > 0
    ? selectedUserExerciseResults
        .sort((a, b) => b.date.seconds - a.date.seconds)[0]
        .date
    : null;

  return (
    <div className="w-full mt-24 h-[80vh]">
      <div className="mb-4 flex justify-center">
        <button
          onClick={fetchData}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? "Загрузка..." : "Получить данные"}
        </button>
      </div>

      <div className="grid grid-cols-[1fr_2fr] divide-x-2 h-full">
        {/* Левая колонка */}
        <div className="flex flex-col overflow-y-auto p-4">
          <h1 className="text-2xl mb-4">Пользователи</h1>

          {users.map(user => (
            <div
              key={user.id}
              onClick={() => setSelectedUser(user)}
              className={`p-3 mb-2 rounded cursor-pointer border bg-gray-300
                ${
                  selectedUser?.id === user.id
                    ? "bg-blue-100 border-blue-400"
                    : "hover:bg-gray-100"
                }`}
            >
              <div className="font-semibold">{user.user_name}</div>
              <div className="text-sm text-gray-500">
                {formatDate(user.date_created)}
              </div>
            </div>
          ))}

          {!users.length && !loading && (
            <div className="text-gray-400">Нет данных</div>
          )}
        </div>

        {/* Правая колонка */}
        <div className="p-6 overflow-y-auto">
          <h1 className="text-2xl mb-4">Информация</h1>

          {!selectedUser && (
            <div className="text-gray-400">
              Выберите пользователя слева
            </div>
          )}

          {selectedUser && (
  <div className="space-y-3">
    <div><b>ID:</b> {selectedUser.user_id}</div>
    <div><b>Имя:</b> {selectedUser.user_name}</div>
    <div><b>Email:</b> {selectedUser.email}</div>
    <div>
      <b>Выполнено упражнений:</b>{" "}
      {selectedUserExerciseResultsCount}
      {lastExerciseDate && (
        <> (последнее: {formatTimestampDate(lastExerciseDate)})</>
      )}
    </div>
    <div>
      <b>Количество SOL:</b> {selectedUserSolCount}
    </div>
    <div><b>Роль:</b> {selectedUser.user_role}</div>
    <div><b>Spanish version:</b> {String(selectedUser.spanish_version)}</div>

    <div>
      <b>Дата создания:</b>{" "}
      {formatTimestampDate(selectedUser.date_created)}
    </div>

    <div>
      <b>Terms of Service:</b>{" "}
      {selectedUser.terms_of_service_date_signed || "—"}
    </div>

    <div>
      <b>Privacy Policy:</b>{" "}
      {selectedUser.privacy_policy_date_signed || "—"}
    </div>
  </div>
)}

{selectedUser && (
  <section className="mt-6" aria-label="Использование ИИ">
    <div className="flex items-center justify-between gap-4 mb-2">
      <h2 className="text-xl">Использование ИИ</h2>
      <button
        onClick={() => setUsageRefresh(value => value + 1)}
        disabled={!currentUsage || currentUsage.loading}
        className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
        type="button"
      >Обновить</button>
    </div>
    {(!currentUsage || currentUsage.loading) && <p role="status">Загрузка данных ИИ…</p>}
    {currentUsage?.error && <p className="text-red-700" role="alert">{currentUsage.error}</p>}
    {currentUsage && !currentUsage.loading && !currentUsage.error && !currentUsage.data && (
      <p>У пользователя нет данных в aiUsage.</p>
    )}
    {currentUsage?.data && (
      <dl className="space-y-2 bg-white bg-opacity-50 rounded-lg p-4">
        {[
          ['ID пользователя', currentUsage.data.userID ?? selectedUserId],
          ['Использовано за текущий период', currentUsage.data.usedCount ?? '—'],
          ['Лимит за период', currentUsage.data.limit ?? '—'],
          ['Всего запросов', currentUsage.data.lifetimeCount ?? '—'],
          ['Последний запрос', formatUsageDate(currentUsage.data.lastRequestAt)],
          ['Начало периода', formatUsageDate(currentUsage.data.windowStartedAt)],
          ['Дата сброса лимита', formatUsageDate(currentUsage.data.resetAt)]
        ].map(([label, value]) => (
          <div key={label} className="flex flex-wrap gap-x-2">
            <dt className="font-semibold">{label}:</dt><dd className="break-all">{value}</dd>
          </div>
        ))}
      </dl>
    )}
  </section>
)}

<div className="mt-6">
      <h2 className="text-xl mb-2">Мнемоники</h2>

      {selectedUserMnemonics.length === 0 && (
        <div className="text-black">
          У пользователя нет мнемоник
        </div>
      )}

      <ul className="space-y-1">
        {selectedUserMnemonics.map(item => (
          <li
            key={item.id}
            className="text-sm"
          >
            <b>{item.forWordID}</b> — {item.mnemonic}
          </li>
        ))}
      </ul>
    </div>
        </div>
      </div>
    </div>
  );
}

export default Statistics;